export default "__VITE_ASSET__BHdjx38C__"